import type { HttpRequest } from '@angular/common/http';

import { CLIENT_CONTEXT_TOKEN_DCS } from '@/api/dcs-api/tokens';
import { CLIENT_CONTEXT_TOKEN_PCS } from '@/api/pcs-api/tokens';
import { CLIENT_CONTEXT_TOKEN_DEFAULT } from '@/api/phs-api/tokens';

/**
 * The app's policy for the library's AUTOMATIC error toast (REQ-025).
 *
 * `@trueform/ui` 0.14.2 rethrows a recognised RFC 9457 ProblemDetails body as a
 * `ProblemDetailsError` (every member the server sent) and offers
 * `TrueformUiConfig.errorToastFilter` to veto the toast PER REQUEST. This app
 * renders DCS, PCS and PHS failures inside its own sheets and forms — the
 * catalog reconcile/validation alerts, the price-hub copy, the lite-calculator
 * feedback and the PCS export — so those three client contexts must not
 * additionally raise the library's raw toast. A 401 is never toasted by the
 * library either way, and the veto only ever silences the toast: the error is
 * always rethrown.
 *
 * The three tokens are DIFFERENT `HttpContextToken` instances (each generated
 * client declares its own), so an unrelated same-named token from another
 * client module does not match; PHS's `CLIENT_CONTEXT_TOKEN_DEFAULT` is a
 * different instance than the auth/pos module's.
 */
export function appErrorToastFilter(req: HttpRequest<unknown>): boolean {
  return (
    !req.context.has(CLIENT_CONTEXT_TOKEN_DCS) &&
    !req.context.has(CLIENT_CONTEXT_TOKEN_PCS) &&
    !req.context.has(CLIENT_CONTEXT_TOKEN_DEFAULT)
  );
}
